import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { customDecode, customEncode, customEncrypt, encrypt } from '@piqet-angular/data';
import { clickTooltipDef, dblclickTooltipDef } from '@piqet-angular/shared';
import { ICellRendererParams } from 'ag-grid-community';
import { SharedService } from 'libs/data/src/lib/services/shared/shared.service';

@Component({
  selector: 'piqet-angular-grid-link-roles-detail',
  templateUrl: './grid-link-roles-detail.component.html',
  styleUrls: ['./grid-link-roles-detail.component.css'],
})
export class GridLinkRolesDetailComponent {
  params: any;
  activatedRoute: any;
  clickTooltipDef = clickTooltipDef;
  dblClickTooltipDef = dblclickTooltipDef;
  productConfigId: any;

  constructor(
    private router: Router,
    private sharedService: SharedService,
    public route: ActivatedRoute
  ) {}

  agInit(params: ICellRendererParams<any, any>): void {
    this.params = params;
    this.activatedRoute = this.route.snapshot.routeConfig?.path;
    const url = location.href.split('/');
    this.productConfigId =
      url.includes('product-configuration') &&
      Number(atob(decodeURIComponent(customDecode(url[6]))));
  }

  refresh(params: ICellRendererParams<any, any>): boolean {
    return false;
  }

  routeToPath() {
    this.sharedService.scenarioNameFunc(this.params.data?.name);
    localStorage.setItem('scenarioName', this.params.data?.name);
    const encodedValue = encodeURIComponent(this.params.data.projectId);
    const valueToEncrypt = `{ "id": ${this.params.data.scenarioId}, "packageScenarioId": ${this.params.data?.packageScenarioId}, "eId": ${this.params.data.scenarioId}}`;
    const encryptedValue = encrypt(valueToEncrypt);
    this.router.navigate(
      [`projects/projects-setting/${customEncode(btoa(encodedValue))}/scenario-configuration`],
      {
        queryParams: {
          param: encryptedValue,
        },
      }
    );
  }

  routeToProductPath() {
    this.sharedService.scenarioNameFunc(this.params.data?.productName);
    localStorage.setItem('scenarioName', this.params.data?.productName);
    // const encodedValue = encodeURIComponent(this.params.data.productId);
    // const valueToEncrypt = `{ "id": ${}`;
    // const encryptedValue = encrypt(valueToEncrypt);
    const encryptedValue = customEncrypt(this.params.data.productId);
    this.router.navigate(
      [`projects/product-configuration/${customEncode(btoa(this.productConfigId))}/configurations`],
      {
        queryParams: {
          param: encryptedValue,
        },
      }
    );
  }

  routeToEdit() {
    const valueToEncrypt = `{ "id": ${this.params.data.id}, "name": "${this.params.data.name}", "reportFormatId": ${this.params.data.reportFormatType}}`;
    this.router.navigate([`my-organization/project-report-setting/org-report-setting`], {
      queryParams: { param: encrypt(valueToEncrypt) },
    });
  }

  routeToRoleDetail(roleId: any, organizationId?: any) {
    let encryptRoleId;
    if (roleId) {
      encryptRoleId = customEncrypt(roleId);
    }
    if (this.activatedRoute == 'admin-roles') {
      this.router.navigate(['administrator/advanced/admin-roles/roleDetails', encryptRoleId], {
        queryParams: { orgId: customEncrypt(organizationId) },
      });
    } else {
      this.router.navigate(['my-organization/roles/roleDetails', encryptRoleId]);
    }
  }
}
